import { render, staticRenderFns } from "./FormVideo.vue?vue&type=template&id=fcff35fe&scoped=true&"
import script from "./FormVideo.vue?vue&type=script&lang=js&"
export * from "./FormVideo.vue?vue&type=script&lang=js&"
import style0 from "./FormVideo.vue?vue&type=style&index=0&id=fcff35fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcff35fe",
  null
  
)

export default component.exports